import { Link } from "react-router-dom"
import * as React from "react"
import ElemCheckbox from "../elements/Checkbox"

interface LegalProps {
	register: Function
	errors: any
}
const Legal: React.FC<LegalProps> = ({ register, errors }) => {
	return (
		<div className=" bg-white max-w-[1324px] relative z-10 px-0 md:px-0  text-left mt-12">
			<ElemCheckbox
				hasError={errors.optInTerms}
				errMsg={"Bitte akzeptiere die Teilnahmebedingungen."}
				label={
					<>
						Ich habe die{" "}
						<Link
							to="/teilnahmebedingungen"
							rel="noopener noreferrer"
							className="text-blue font-AmsiBlack underline"
							onClick={() => {
								try {
									// eslint-disable-next-line
									let dataLayer = window["dataLayer"] || []
									dataLayer.push({ event: "form", link: "teilnahmebedingungen" })
								} catch (e) {}
							}}
						>
							Teilnahmebedingungen
						</Link>{" "} gelesen und akzeptiere diese.*
					</>
				}
			>
				<input {...register("optInTerms", { required: true })} type="checkbox" className="w-1 h-1 opacity-0 absolute peer" />
			</ElemCheckbox>
			<ElemCheckbox
				hasError={errors.optInPrivacy}
				errMsg={"Bitte akzeptiere die Datenschutzbestimmungen."}
				label={
					<>
						Ich habe die{" "} <a
							href="https://www.trekbars.com/en/privacy-policy"
							target="_blank"
							rel="noopener noreferrer"
							className="text-blue font-AmsiBlack underline"
							onClick={() => {
								try {
									// eslint-disable-next-line
									let dataLayer = window["dataLayer"] || []
									dataLayer.push({ event: "form", link: "datenschutz" })
								} catch (e) {}
							}}
						>
							Datenschutzbestimmungen
						</a>{" "}gelesen und akzeptiere diese.*
					</>
				}
			>
				<input {...register("optInPrivacy", { required: true })} type="checkbox" className="w-1 h-1 opacity-0 absolute peer" />
			</ElemCheckbox>
		</div>
	)
}

export default Legal
